const AppMessage = {
  Poppu: {
    register:
      "Thank you for creating your account to continue your registration. We have sent you an e-mail to verify your account.",
  },
};

export default AppMessage;
